/**
 * Hub 文章示例图（封面、大图、测评 showcase）
 */
var HUB_DEMO_IMAGES = {
  'gallery-fallback': require('@/assets/images/gallery-1.webp'),
  'seedream-product': require('@/assets/images/social-luxury-bag.jpg'),
  'seedream-lifestyle': require('@/assets/images/social-tropical-cocktail.jpg'),
  'seedream-sneaker': require('@/assets/images/social-sneaker-drop.jpg'),
  'seedream-interior': require('@/assets/images/home-scandi-living.jpg'),
  'seedream-hero': require('@/assets/images/social-boxing-gloves.jpg'),
  'seedream-seo-grid': require('@/assets/images/seedream/0217834949526105a9f949eb72c2227dac5c405ca3d9cd6c996b9_0.webp'),
  'seedream-seo-still-life': require('@/assets/images/seedream/021783495149924e4fd4c285bd49f804239cddc30345c48dc6024_0.webp'),
  'seedream-seo-market': require('@/assets/images/seedream/994ae318-58d7-4ffa-98e1-ea97553ff0c0.webp'),
  'seedream-seo-vases': require('@/assets/images/seedream/021783495389730ffa263910bfaab0198f27d0234753c494fd2fa_0.webp'),
  'seedream-seo-studio-edit': require('@/assets/images/seedream/02efd75c-db3e-4cac-8252-b34dd782c1ab.webp'),
  'seedream-seo-rain-character': require('@/assets/images/seedream/02178349553182068d2074cd11e877100f87d4b1716fc61941c2e_0.webp'),
  'seedream-seo-coastal-city': require('@/assets/images/seedream/0217834956211361c17ef9c173e8babb4a0658490f0169e937059_0.webp'),
  'seedream-seo-perfume': require('@/assets/images/seedream/021783495894855ad8f78454eef31552c89ebf2f2559e7d2d47a0_0.webp'),
  'flux2-seo-landscape': require('@/assets/images/flux2/1a2627bd-61e0-406a-9308-19f2883d004e.webp'),
  'flux2-seo-abstract': require('@/assets/images/flux2/sample.webp'),
  'flux2-seo-anime': require('@/assets/images/flux2/57047990-2e26-4b44-bacf-f10bca5ee70d.webp'),
  'flux2-seo-watch': require('@/assets/images/flux2/b1d818f0-ff1f-4612-b586-62f75e14466c.webp'),
  'flux2-seo-tram': require('@/assets/images/flux2/2026b767-edcb-4441-b70e-a6d94ae6ebb9.webp'),
  'flux2-seo-blueberry': require('@/assets/images/flux2/c2f47f20-00b4-4cec-b972-e7a69d40be56.webp'),
  'flux2-seo-cake': require('@/assets/images/flux2/2258b023-29ba-433f-b909-88f542adc3b9.webp'),
  'flux2-seo-perfume': require('@/assets/images/flux2/2a4b147b-31c2-4ded-a626-d7e209fb751b.webp'),
  'gpt-seo-perfume': require('@/assets/images/gptImage/perfume-editorial.jpg'),
  'gpt-seo-rainy-city': require('@/assets/images/gptImage/rainy-city-tram.jpg'),
  'gpt-seo-cake': require('@/assets/images/gptImage/strawberry-cake.jpg'),
  'gpt-seo-lighthouse': require('@/assets/images/gptImage/lighthouse-travel-poster.jpg'),
  'gpt-seo-tech-poster': require('@/assets/images/gptImage/create-the-future.jpg'),
  'gpt-seo-coffee': require('@/assets/images/gptImage/miral-roast-package.jpg'),
  'gpt-seo-potter': require('@/assets/images/gptImage/ceramic-artist.jpg'),
  'qwen-seo-product': require('@/assets/images/qwenImage2Pro/32ccbe94-155c-4873-9e85-602969ecb6e4.webp'),
  'qwen-seo-portrait': require('@/assets/images/qwenImage2Pro/b4c88e78-6c88-4db5-9ea2-a6041609a380.webp'),
  'qwen-seo-reading': require('@/assets/images/qwenImage2Pro/f9f87426-60d9-4f97-a372-7cb55b5bf7de.webp'),
  'qwen-seo-future-city': require('@/assets/images/qwenImage2Pro/9bf30d3e-5ec1-4180-9165-519f7b0765a4.webp'),
  'qwen-seo-lamp': require('@/assets/images/qwenImage2Pro/c4581d5b-f28a-4ae5-8bb2-b110c30d954c.webp'),
  'qwen-seo-coast': require('@/assets/images/qwenImage2Pro/e2bd1179-48db-4ce6-a713-2a0a62dd5dd5.webp'),
  'qwen-seo-potter': require('@/assets/images/qwenImage2Pro/3204b3e8-c5ca-40b4-afa9-a65f6dd806e2.webp'),
  'sd-seo-vase': require('@/assets/images/stableDiffusion/1783501013638.webp'),
  'sd-seo-portrait': require('@/assets/images/stableDiffusion/1783501332038.webp'),
  'sd-seo-coast': require('@/assets/images/stableDiffusion/1783501396803.webp'),
  'sd-seo-poster': require('@/assets/images/stableDiffusion/0217835023294345bd2f0b9e6315ce45b86fb4e22ec7496156d5f_0.webp'),
  'sd-seo-still-life': require('@/assets/images/stableDiffusion/1783501741652.webp'),
  'sd-seo-reading': require('@/assets/images/stableDiffusion/1783501817217.webp'),
  'sd-seo-potter': require('@/assets/images/stableDiffusion/021783502374347ebd7c24e3cae4a4b683f52566c3e30e2cb26b5_0.webp'),
  'z-seo-greenhouse': require('@/assets/images/zImageTurbo/b1057f7b-3e0e-9687-aa55-56cfed42147a0.webp'),
  'z-seo-bakery': require('@/assets/images/zImageTurbo/a8dbab92-cfb4-928b-bd20-4f01835aa0ac0.webp'),
  'z-seo-market': require('@/assets/images/zImageTurbo/b2964bd5-066f-90b6-8c86-91dad79e44120.webp'),
  'z-seo-poster': require('@/assets/images/zImageTurbo/2d5a0c7e-3ef6-9433-be0d-606be80f99e80.webp'),
  'z-seo-skincare': require('@/assets/images/zImageTurbo/f688ab6d-a723-969d-8df1-fbac721e66350.webp'),
  'z-seo-violin-maker': require('@/assets/images/zImageTurbo/715e19f5-fea4-9361-a1e3-0f04d595db660.webp'),
  'midjourney-seo-traveler': require('@/assets/images/midjourney/1783505533006329.webp'),
  'midjourney-seo-swordswoman': require('@/assets/images/midjourney/45f1eae9-39b9-4cc9-8a4e-e597aa4d344b.webp'),
  'midjourney-seo-vase': require('@/assets/images/midjourney/1783506116812275.webp'),
  'midjourney-seo-neon-alley': require('@/assets/images/midjourney/1783506281563151.webp'),
  'midjourney-seo-musician': require('@/assets/images/midjourney/1783506420066100.webp'),
  'midjourney-seo-alchemist': require('@/assets/images/midjourney/1783506547640511.webp'),
  'midjourney-seo-hummingbird': require('@/assets/images/midjourney/55889f96-30d2-4032-9340-2d27090394e6.webp'),
  'flux-watch': require('@/assets/images/flux-kontext.webp'),
  'flux-coffee': require('@/assets/images/flux-kontext-2.webp'),
  'flux-car': require('@/assets/images/flux-kontext-3.webp'),
  'flux-skincare': require('@/assets/images/product-showcase.webp'),
  'flux-hero': require('@/assets/images/hd-upscale.webp'),
  'midjourney-demo': require('@/assets/images/midjourney-demo.webp'),
  'midjourney-hero': require('@/assets/images/fantasy-world.webp'),
  'midjourney-character': require('@/assets/images/anime-scene.webp'),
  'gpt-image-demo': require('@/assets/images/gpt-image-demo-1.webp'),
  'gpt-hero': require('@/assets/images/ai-thumbnail.webp'),
  'qwen-image-demo': require('@/assets/images/qwen-image-2-0-pro.jpg'),
  'qwen-hero': require('@/assets/images/ai-thumbnail.webp'),
  'z-image-demo': require('@/assets/images/z-image-turbo.jpg'),
  'z-hero': require('@/assets/images/social-shorts.jpg'),
  'sd-demo': require('@/assets/images/anime-portrait.jpg'),
  'sd-hero': require('@/assets/images/fantasy-world.webp'),
  'watermark-cover': require('@/assets/images/watermark-examples/full-image-watermark-after.webp'),
  'watermark-full-before': require('@/assets/images/watermark-examples/full-image-watermark-original.webp'),
  'watermark-full-after': require('@/assets/images/watermark-examples/full-image-watermark-after.webp'),
  'watermark-timestamp-before': require('@/assets/images/watermark-examples/timestamp-original.webp'),
  'watermark-timestamp-after': require('@/assets/images/watermark-examples/timestamp-after.webp'),
  'watermark-logo-before': require('@/assets/images/watermark-examples/logo-original.webp'),
  'watermark-logo-after': require('@/assets/images/watermark-examples/logo-after.webp'),
  'watermark-draft-before': require('@/assets/images/watermark-examples/draft-marks-original.webp'),
  'watermark-draft-after': require('@/assets/images/watermark-examples/draft-marks-after.webp'),
  'background-remover-before': require('@/assets/images/hub/background-remover-product-before.jpg'),
  'background-remover-after': require('@/assets/images/hub/background-remover-product-after.png'),
  'ecommerce-background-remover-before': require('@/assets/images/hub/ecommerce-product-background-before.jpg'),
  'ecommerce-background-remover-after': require('@/assets/images/hub/ecommerce-product-background-after.png'),
  'portrait-background-remover-before': require('@/assets/images/hub/portrait-background-remover-before.jpg'),
  'portrait-background-remover-after': require('@/assets/images/hub/portrait-background-remover-after.jpg'),
  'portrait-avatar-before': require('@/assets/images/hub/portrait-avatar-before.jpg'),
  'portrait-avatar-after': require('@/assets/images/hub/portrait-avatar-after.jpg'),
  'portrait-id-before': require('@/assets/images/hub/portrait-id-before.jpg'),
  'portrait-id-after': require('@/assets/images/hub/portrait-id-after.jpg'),
  'portrait-linkedin-before': require('@/assets/images/hub/portrait-linkedin-before.jpg'),
  'portrait-linkedin-after': require('@/assets/images/hub/portrait-linkedin-after.jpg'),
  'background-changer-before': require('@/assets/images/hub/background-changer-before.jpg'),
  'background-changer-after': require('@/assets/images/hub/background-changer-after.jpg'),
  'changer-lifestyle-before': require('@/assets/images/hub/changer-lifestyle-before.jpg'),
  'changer-lifestyle-after': require('@/assets/images/hub/changer-lifestyle-after.jpg'),
  'changer-social-before': require('@/assets/images/hub/changer-social-before.jpg'),
  'changer-social-after': require('@/assets/images/hub/changer-social-after.jpg'),
  'changer-poster-before': require('@/assets/images/hub/changer-poster-before.jpg'),
  'changer-poster-after': require('@/assets/images/hub/changer-poster-after.jpg'),
  'handwriting-cover': require('@/assets/images/handwritten-exams/contract-erased.webp'),
  'handwriting-contract-before': require('@/assets/images/handwritten-exams/contract-original.webp'),
  'handwriting-contract-after': require('@/assets/images/handwritten-exams/contract-erased.webp'),
  'handwriting-exam-ko-before': require('@/assets/images/handwritten-exams/exam-ko-original.webp'),
  'handwriting-exam-ko-after': require('@/assets/images/handwritten-exams/exam-ko-erased.webp'),
  'handwriting-exam-zh-before': require('@/assets/images/handwritten-exams/exam-zh-original.webp'),
  'handwriting-exam-zh-after': require('@/assets/images/handwritten-exams/exam-zh-erased.webp'),
  'handwriting-scan-before': require('@/assets/images/handwritten-exams/scanned-document-original.webp'),
  'handwriting-scan-after': require('@/assets/images/handwritten-exams/scanned-document-erased.webp'),
  'doc-crop-cover': require('@/assets/images/doc-crop-examples/dewarp-after.webp'),
  'doc-example-crop-before': require('@/assets/images/doc-crop-examples/crop-before.webp'),
  'doc-example-crop-after': require('@/assets/images/doc-crop-examples/crop-after.webp'),
  'doc-example-dewarp-before': require('@/assets/images/doc-crop-examples/dewarp-before.webp'),
  'doc-example-dewarp-after': require('@/assets/images/doc-crop-examples/dewarp-after.webp'),
  'doc-example-deshadow-before': require('@/assets/images/doc-crop-examples/deshadow-before.webp'),
  'doc-example-deshadow-after': require('@/assets/images/doc-crop-examples/deshadow-after.webp'),
  'doc-example-sharpen-before': require('@/assets/images/doc-crop-examples/sharpen-before.webp'),
  'doc-example-sharpen-after': require('@/assets/images/doc-crop-examples/sharpen-after.webp')
}

var ARTICLE_COVER_IMAGES = {
  'seedream-ai-image-generator-review': 'seedream-product',
  'flux-ai-image-generator-review': 'flux-watch',
  'midjourney-alternative-online': 'midjourney-seo-traveler',
  'gpt-image-generator-guide': 'gpt-image-demo',
  'qwen-image-generator-review': 'qwen-image-demo',
  'z-image-ai-generator-review': 'z-image-demo',
  'stable-diffusion-online-generator': 'sd-demo',
  'ai-watermark-remover-online': 'watermark-cover',
  'ai-background-remover-online': 'background-remover-after',
  'ecommerce-product-background-removal': 'ecommerce-background-remover-after',
  'ai-portrait-background-remover': 'portrait-linkedin-after',
  'ai-background-changer-online': 'changer-lifestyle-after',
  'handwriting-eraser-online': 'handwriting-cover',
  'image-crop-dewarp-online': 'doc-crop-cover'
}

function isPublicHubImagePath(value) {
  var path = String(value || '')
  return path.charAt(0) === '/' || /^https?:\/\//i.test(path)
}

function getHubDemoImage(imageKey) {
  if (isPublicHubImagePath(imageKey)) return imageKey
  return HUB_DEMO_IMAGES[imageKey] || HUB_DEMO_IMAGES['gallery-fallback'] || ''
}

function getArticleCoverImage(article) {
  if (!article) return getHubDemoImage('gallery-fallback')
  if (article.coverImage) return getHubDemoImage(article.coverImage)
  var key = ARTICLE_COVER_IMAGES[article.slug]
  return getHubDemoImage(key || 'gallery-fallback')
}

module.exports = {
  HUB_DEMO_IMAGES: HUB_DEMO_IMAGES,
  ARTICLE_COVER_IMAGES: ARTICLE_COVER_IMAGES,
  getHubDemoImage: getHubDemoImage,
  getArticleCoverImage: getArticleCoverImage
}
